export default {"src":"/_next/static/media/a-series_contemporary_hinged.52cfe966.svg","height":1000,"width":1000};